import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '@ciam/library';
import { timeout } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Contact2faEditResponse } from 'src/app/shared/models/Contact2faEditResponse';
import { Address, Contact, Contact2faEditRequest, Phone, PhoneAncillary } from 'src/app/shared/models/Contact2faEditRequest';
import { SessionStorageService } from 'src/app/shared/services/sessionStorage-service/session-storage.service';

export enum PARAMS {
  MOCK = 'mock',
  STATUS = 'status'
}

@Injectable({
  providedIn: 'root'
})
export class Contact2faEditService {
  constructor(
    private http: HttpClient,
    private config: ConfigurationService,
    private sessionStorageService: SessionStorageService
  ) { }

  updateContactInformation2faEdit(queryParams: any, contactParams: any, isAddSecondaryNumber?: boolean): Observable<Contact2faEditResponse> {
    let url = this.config.select<string>('endpoints.contactInfoV1.url');
    if(queryParams.params && queryParams.get(PARAMS.MOCK) === 'true') {
      const status = queryParams.get(PARAMS.STATUS);
      if( status === '400') {
        url += `?status=${status}`;
      } else if (status === '401'){
        url += `?status=${status}`;
      } else if (status === '403'){
        url += `?status=${status}`;
      } else if (status === '404'){
        url += `?status=${status}`;
      } else if (status === '500'){
        url += `?status=${status}`;
      } else if (status === '1050') {
        url += `?status=${status}`;
      }
    }
    const body = this.generateContactRequest(contactParams, isAddSecondaryNumber);
    return this.http.put(url, body, { withCredentials: true });
  }

  generateContactRequest(contactParams: any, isAddSecondaryNumber: boolean): Contact2faEditRequest {
    const payload = {
      parsedContactAddress: {
        contact: this.toContact(contactParams),
        contactAncillaryDetail: this.toContactAncillaryDetail(contactParams),
        address: this.toAddress(contactParams)
      }
    };

    const secondaryPhonePayload = {
      parsedContactAddress: {
        contactAncillaryDetail: this.toAddSecondaryContactAncillaryDetails(contactParams)
      }
    };

    if (contactParams.currentPassword) {
      payload['password'] = contactParams.currentPassword;
    }
    return isAddSecondaryNumber ? secondaryPhonePayload : payload;
  }

  toContact(data: any): Contact {
    return {
      personName: {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        middleName: '',
        suffix: ''
      },
      companyName: this.sessionStorageService.getItem('companyName').toString(),
      phoneNumber: data.phoneNumber || '',
      emailAddress: data.email || '',
      faxNumber: '',
      title: ''
    };
  }

  toAddSecondaryContactAncillaryDetails(data: any): PhoneAncillary {
    const phones = [];

    phones.push({
      type: 'MOBILE',
      number: {
        countryCode: data.secondaryPhoneCountryCode || '',
        localNumber: data.secondaryPhoneNumber || ''
      },
      permisssions: {}
    });

    return { phoneNumberDetails: phones };
  }

  toContactAncillaryDetail(data: any): PhoneAncillary {
    const phones = [];
    phones.push({
      type: 'HOME',
      number: {
        countryCode: data.phoneCountryCode || '',
        localNumber: data.phoneNumber || ''
      },
      permisssions: {}
    } as Phone);

    phones.push({
      type: 'MOBILE',
      number: {
        countryCode: data.secondaryPhoneCountryCode || '',
        localNumber: data.secondaryPhoneNumber || ''
      },
      permisssions: {}
    });

    phones.push({
      type: 'FAX',
      number: {
        countryCode: '',
        localNumber: ''
      },
      permisssions: {}
    });

    return { phoneNumberDetails: phones };
  }

  toAddress(data: any): Address {
    return {
      streetLines: [data.addressLine1, data.addressLine2].filter(line => line?.trim().length),
      city: data.city || '',
      stateOrProvinceCode: (data.stateOrProvince || '').toUpperCase(),
      postalCode: data.zipCode || '',
      countryCode: (data.countryCode || '').toUpperCase()
    };
  }

}
